import script from "./ContactComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=2839472e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2839472e"]])

export default __exports__